/**
 * Translate a given key (string) based in a given dictionary.
 * Obs: when the given key is not present in dictionary, it will return the given key untranslated.
 * @param {string} key - The key to be translated
 * @param {Object.<string, string>} dictionary - The dictionary to be used in translation
 * @param {Object} [options={compositeKeySeparator:''}]
 * @param {string} [options.compositeKeySeparator=''] - Used when translating a composite key with separators
 * @returns {string}
 */
const fromToKey = (key, dictionary, { compositeKeySeparator = '' } = {}) => {
  if (compositeKeySeparator && compositeKeySeparator !== '') {
    return key
      .split(compositeKeySeparator)
      .map(localKey => dictionary[localKey] || localKey)
      .join(compositeKeySeparator);
  }

  return dictionary[key] || key;
};

module.exports = fromToKey;
